import Vue from 'vue'
import App from './App.vue'

//引用ElementUI
import ElementUI from 'element-ui'
//使用element-ui的Css样式
import 'element-ui/lib/theme-chalk/index.css'
import axiosUtils from "@/http/axiosUtils"
//1.安装pubsub: npm i pubsub-js
//2，导入pubsub
import pubsub from 'pubsub-js'
//导入routerManeger
import router from "@/routerManeger";
import consoleLog from "@/utils/consoleLog";

Vue.use(axiosUtils)
///饿了么UI框架，小寸尺
Vue.use(ElementUI, {size: 'small'})
//使用pubsub，消息订阅与发布,类似eventBus
Vue.use(pubsub)
Vue.use(consoleLog)
Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
    created() {
        ///全局router
        window.globalRouter = this.$router
        ///全局context
        window.globalContext = this
    }
}).$mount('#app')
